import { render, staticRenderFns } from "./page-save.vue?vue&type=template&id=3fcb1ab4&"
import script from "./page-save.vue?vue&type=script&lang=js&"
export * from "./page-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports